<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3">
				<div class="navbar navbar-expand-lg">
					<!-- Page title -->
					<loading type="header" v-if="loading" />
					<div v-if="!loading" class="navbar-text nav-title flex" id="pageTitle">
						<i
							class="fas fa-fw fa-lock-alt"
							v-if="item.isScored"
							v-tippy="{ placement: 'bottom-start' }"
							title="This item has been used for scoring, so some options can no longer be changed"
						></i>
						{{ item.name }}
					</div>
				</div>

				<div class="content-main" style="background-color:white">
					<!-- Page content goes here -->
					<div class="h-100" v-if="!loading">
						<div class="d-sm-flex b-t h-100">
							<div class="w w-auto-xs light bg b-r">
								<div class="py-3">
									<div class="nav-active-border left b-primary">
										<ul class="nav flex-column nav-sm">
											<li class="nav-item">
												<a
													class="nav-link"
													:class="{ active: tab == 1, show: tab == 1 }"
													href="#"
													data-toggle="tab"
													data-target="#tab-1"
												>
													{{ $t("label.page.item_details") }}
													<i
														class="valid-hint text fa fa-angle-left"
														:class="{ invalid: !valid.group('details') }"
													></i>
												</a>
											</li>
											<li class="nav-item">
												<a
													class="nav-link"
													:class="{ active: tab == 2, show: tab == 2 }"
													href="#"
													data-toggle="tab"
													data-target="#tab-2"
												>
													{{ $t("label.page.scoring_setup") }}
													<i
														class="valid-hint text fa fa-angle-left"
														:class="{ invalid: !valid.group('scoring') }"
													></i>
												</a>
											</li>
											<li class="nav-item">
												<a
													class="nav-link"
													:class="{ active: tab == 3, show: tab == 3 }"
													href="#"
													data-toggle="tab"
													data-target="#tab-3"
													>{{ $t("label.page.viewer_controls") }}</a
												>
											</li>
											<li class="nav-item">
												<a
													class="nav-link"
													:class="{ active: tab == 4, show: tab == 4 }"
													href="#"
													data-toggle="tab"
													data-target="#tab-4"
													>{{ $t("label.page.resources") }}</a
												>
											</li>
											<!-- <li class="nav-item">
												<a class="nav-link" :class="{active: tab == 5, show: tab == 5}" href="#" data-toggle="tab"
												 data-target="#tab-5">{{ $t("label.page.quality_settings") }}</a>
											</li>
											<li class="nav-item">
												<a class="nav-link" :class="{active: tab == 6, show: tab == 6}" href="#" data-toggle="tab"
												 data-target="#tab-6">{{ $t("label.page.integrations") }}</a>
											</li>
											<li class="nav-item">
												<a class="nav-link" :class="{active: tab == 7, show: tab == 7}" href="#" data-toggle="tab"
												 data-target="#tab-7">{{ $t("label.page.flag_codes") }}</a>
											</li>-->
										</ul>
									</div>
								</div>
							</div>

							<edit-pane :cancel="loadData" :save="saveItem" :dirty="dirty" :valid="valid">
								<div class="tab-content">
									<!-- Item Details -->
									<item-edit-details
										id="tab-1"
										:item="item"
										:valid="valid"
										:defaultTab="tab == 1"
									></item-edit-details>

									<!-- Scoring Setup -->
									<item-edit-scoring
										id="tab-2"
										:item="item"
										:dirty="dirty"
										:valid="valid"
										:defaultTab="tab == 2"
									></item-edit-scoring>

									<!-- Viewer Controls -->
									<item-edit-viewer id="tab-3" :item="item" :defaultTab="tab == 3"></item-edit-viewer>

									<!-- Resources -->
									<item-edit-resources
										id="tab-4"
										:item="item"
										:originalResources="originalResources"
										:dirty="dirty"
										:valid="valid"
										:save="saveItem"
										:defaultTab="tab == 4"
									></item-edit-resources>
								</div>
							</edit-pane>
							<save-optional-modal
								:dirty="dirty"
								:valid="valid"
								:save="saveItem"
								:next="saveOptNext"
								:cancel="saveOptCancel"
								objectText="Item"
								:objectName="item.name"
								actionText="leave the page"
								v-model="saveOptModal"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}
.invalid {
	color: red;
}
</style>

<script>
import ItemEditDetails from "@/components/item/ItemEditDetails";
import ItemEditScoring from "@/components/item/ItemEditScoring";
import ItemEditViewer from "@/components/item/ItemEditViewer";
import ItemEditResources from "@/components/item/ItemEditResources";
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";

import ItemService from "@/services/ItemService";
import TenantService from "@/services/TenantService";
import ValidationService from "@/services/ValidationService";
import fs from "@/services/FormatService";
import notie from "@/services/NotieService";
import Utils from "@/services/Utils";

export default {
	name: "ItemEdit",

	props: ["user", "params", "query"],

	components: {
		"item-edit-details": ItemEditDetails,
		"item-edit-scoring": ItemEditScoring,
		"item-edit-viewer": ItemEditViewer,
		"item-edit-resources": ItemEditResources,
		"edit-pane": EditPane,
		"save-optional-modal": SaveOptionalModal
	},

	data() {
		return {
			fs: fs,
			tab: 1,
			item: {
				validity_config: {},
				qualification_config: {},
				calibration_config: {},
				learnosity_config: {},
				crase_config: {},
				erater_config: {},
				api_export_config: {},
				resources: []
			},
			originalResources: [],
			dirty: false,
			loading: true,
			valid: {},
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {}
		};
	},

	created() {
		this.loadData();
		this.initValidation();

		if (this.query.tab) {
			this.tab = this.query.tab;
		}
	},

	watch: {},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {
		initValidation() {
			this.valid = ValidationService.newValidator({
				name: {
					group: "details",
					errorMsg: "You must assign a name",
					func: () => {
						return this.item && this.item.name && this.item.name != "";
					}
				},
				ref: {
					group: "details",
					errorMsg: "You must assign a reference ID",
					func: () => {
						return this.item && this.item.ref_id && this.item.ref_id != "";
					}
				},
				ref_char: {
					group: "details",
					errorMsg:
						"Reference IDs may not contain spaces or any of the following characters: ! # % ^ * ( )  / [ ] { } < > ? | ' \" :",
					func: () => {
						return this.item && this.item.ref_id && fs.isGoodRefID(this.item.ref_id);
					}
				},
				rubric: {
					group: "scoring",
					errorMsg: "You must choose a rubric",
					func: () => {
						return this.item && this.item.rubric && this.item.rubric_id;
					}
				},
				type: {
					group: "scoring",
					errorMsg: "You must choose a resolution rule",
					func: () => {
						return this.item && this.item.type;
					}
				}
			});
		},

		blankItem() {
			return {
				validity_config: {},
				qualification_config: {},
				calibration_config: {},
				learnosity_config: {},
				crase_config: {},
				erater_config: {},
				api_export_config: {},
				exception_config: {},
				reliability_percent: 100,
				use_considerations: true,
				use_comments: true,
				resources: []
			};
		},

		watchChanges() {
			if (this.unwatch) {
				this.unwatch();
			}
			this.unwatch = this.$watch(
				"item",
				(newc, old) => {
					// console.log(Utils.diff(newc, old));
					// console.log("marking dirty");
					this.dirty = true;
				},
				{ deep: true }
			);
		},

		loadData() {
			this.dirty = false;

			if (this.params.id != "new") {
				return Promise.all([
					ItemService.getItem(this.params.id),
					ItemService.isScored(this.params.id),
					TenantService.getClient("current")
				])
					.then(resps => {
						//resps[0] - getItem
						this.item = resps[0].data;
						this.originalResources = _.cloneDeep(this.item.resources);
						this.loading = false;

						//resps[1] - isScored
						this.item.isScored = resps[1].data;

						//resps[2] - getClient
						this.loadAlerts(this.item, resps[2].data);
						this.watchChanges();
					})
					.catch(err => {
						notie.error("Item not found, adding new item instead", err);
						this.$router.replace("/items/new");
					});
			} else {
				return TenantService.getClient("current")
					.then(resp => {
						this.item = this.blankItem();
						this.$set(this.item, "name", "New Item");
						this.$set(this.item, "ref_id", "new_item");
						this.loading = false;

						this.loadAlerts(this.item, resp.data);
						this.watchChanges();
					})
					.catch(err => {
						notie.error("Failed to initialize item", err);
					});
			}
		},

		loadAlerts(item, client) {
			if (client.alerts) {
				item.avail_alerts = [];

				_.each(client.alerts, client_alert => {
					//Make an option object for each possible alert
					item.avail_alerts.push({
						alert_id: client_alert.id,
						code: client_alert.code,
						description: client_alert.description,
						item_id: item.id
					});
				});
			}
		},

		saveItem() {
			return ItemService.saveItem(this.item)
				.then(resp => {
					notie.info("Item Saved");
					if (this.item.id != resp.data.id) {
						this.$router.replace("/items/" + resp.data.id);
					}
					this.loadData();
				})
				.catch(err => {
					console.log(err);
					notie.error("Failed to save item", err);
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/ItemEdit.vue